/* © CNES */
import { useEffect, useState } from 'react';
import './CollectionHeader.scss';

/**
 * Collection Header Props.
 */
interface CollectionHeaderProps {
  data: {
    name: string | undefined;
    endDateTime: string | null;
    startDateTime: string | null;
    storageMode: string | null;
    totalSize: number | null;
  };
  isDatalakeAvailable?: string;
}

/**
 * Collection Header to display Product details relative to Collection.
 * @param data CollectionHeaderProps.
 * @returns Element.
 */
export const CollectionHeader = ({
  data,
  isDatalakeAvailable,
}: CollectionHeaderProps) => {
  const [storageModeValue, setStorageModeValue] = useState<string | null>(null);

  useEffect(() => {
    if (isDatalakeAvailable === 'available' || data.storageMode) {
      setStorageModeValue(data.storageMode);
    } else if (isDatalakeAvailable === 'loading') {
      setStorageModeValue('Pending response...');
    } else if (isDatalakeAvailable === 'unavailable') {
      setStorageModeValue('Datalake unavailable');
    }
  }, [isDatalakeAvailable, data]);

  return (
    <div className="CollectionHeader">
      <div className="HeaderRow">
        <p className="RowValue">{data.name}</p>
        <p className="RowLabel">Collection</p>
      </div>
      <div className="HeaderRow">
        <p className="RowValue">{data.startDateTime}</p>
        <p className="RowLabel">Sensing start</p>
      </div>
      <div className="HeaderRow">
        <p className="RowValue">{data.endDateTime}</p>
        <p className="RowLabel">Sensing end</p>
      </div>
      <div className="HeaderRow">
        <p className="RowValue">{storageModeValue || data.storageMode}</p>
        <p className="RowLabel">Storage mode</p>
      </div>
      <div className="HeaderRow">
        <p className="RowValue">{data.totalSize?.toFixed(2)} Mo</p>
        <p className="RowLabel">Total size</p>
      </div>
    </div>
  );
};
